import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ExchangeKey } from "../db";


export interface Provider {
  id: number;
  name: string;
  need_password: boolean;
}

interface ExchangeSwitcherState {
  connectedKeys: ExchangeKey[];
  selectedExchange?: ExchangeKey;
  loadingKeys: boolean;
  isSideBarCollapsed: boolean;
  fetched: boolean;
  providers: Provider[];
}

const initialState: ExchangeSwitcherState = {
  connectedKeys: [],
  loadingKeys: true,
  selectedExchange: undefined,
  isSideBarCollapsed: false,
  fetched: false,
  providers: [],
};

const exchangeSwitcherSlice = createSlice({
  name: "exchange-switcher",
  initialState,
  reducers: {
    setConnectedKeys(state, action: PayloadAction<ExchangeKey[]>) {
      state.connectedKeys = action.payload;
      state.fetched = true;
    },
    setProviders(state, action: PayloadAction<Provider[]>) {
      state.providers = action.payload;
    },
    setSelectedExchange(state, action: PayloadAction<ExchangeKey>) {
      state.selectedExchange = action.payload;
    },
    toggleLoadingKeys(state, action: PayloadAction<boolean>) {
      state.loadingKeys = action.payload;
    },
    toggleSidebar(state, action: PayloadAction<boolean>) {
      state.isSideBarCollapsed = action.payload;
    },
    toggleFetched(state, action: PayloadAction<boolean>) {
      state.fetched = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase("clear", () => initialState);
  },
});

export const {
  setConnectedKeys,
  setProviders,
  setSelectedExchange,
  toggleLoadingKeys,
  toggleSidebar,
  toggleFetched,
} = exchangeSwitcherSlice.actions;
export default exchangeSwitcherSlice.reducer;
